var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header",class:_vm.hasBackground?'has-background':''},[_c('p',{staticClass:"page-title"},[_vm._t("default")],2),(_vm.hasLine)?_c('span',{staticClass:"line"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }